import {TweenMax, Power3} from 'gsap';

class AnimateButtonHelper {
  constructor(props) {
    this.currentlyAnimating = false;

    this.button = props.button;
    this.buttonFill = props.buttonFill;
    this.onComplete = props.onComplete;

    this.setupEvents()
  }

  setupEvents() {
    this.button.addEventListener('mouseenter', this.handleLoopAnimation.bind(this));
    this.button.addEventListener('mouseleave', this.cancelLoopAnimation.bind(this));

    this.button.addEventListener('mousedown', this.handleMouseDown.bind(this));
  }

  disable() {
    this.button.removeEventListener('mouseenter', this.handleLoopAnimation.bind(this));
    this.button.removeEventListener('mouseleave', this.cancelLoopAnimation.bind(this));

    this.button.removeEventListener('mousedown', this.handleMouseDown.bind(this));
  }

  handleLoopAnimation() {
    if (!this.currentlyAnimating) this.animateActiveButton();

    this.interval = setInterval(() => {
      this.queueButtonAnimation();
    }, 1500);
  }

  cancelLoopAnimation() {
    clearInterval(this.interval);
  }

  handleMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.tween) {
      this.tween.kill();
      this.currentlyAnimating = false;
      TweenMax.set(this.buttonFill, { 'clearProps': 'all' });
    }

    this.cancelLoopAnimation();
  }

  queueButtonAnimation(delay = 500) {
    if (this.currentlyAnimating) {
      setTimeout(() => {
        this.queueButtonAnimation(delay);
      }, delay);

      return;
    }

    this.animateActiveButton();
  }

  animateActiveButton() {
    if (this.currentlyAnimating) return;
    this.currentlyAnimating = true;

    this.tween = TweenMax.to(this.buttonFill, 0.5, {
      'x': '30%',
      'ease': Power1.easeIn,
      'onComplete': () => {
        this.currentlyAnimating = false;

        TweenMax.set(this.buttonFill, { 'clearProps': 'all' });
      },
    });
  }
}

export default AnimateButtonHelper;



// WEBPACK FOOTER //
// ./src/client/helpers/utilities/animate-button.js